import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '@app/authentication/services/authentication.service';
import { JWTUser } from '@models/jwt-data.model';
import { UserBusinessType } from '@app/shared/models/enums/user-business-type.enum';
import { Log } from 'ng2-logger';
import { TranslateService } from '@ngx-translate/core';
import { NavigationService } from '@app/core/services/navigation.service';

@Component({
    selector: 'app-technical-production-badge-scan',
    templateUrl: './technical-production-badge-scan.component.html',
    styleUrls: ['./technical-production-badge-scan.component.scss']
})
export class TechnicalProductionBadgeScanComponent implements OnInit {
    private _logger = Log.create(TechnicalProductionBadgeScanComponent.name);

    isLoading = false;
    errorMessage: string = null;
    currentUser: JWTUser;

    constructor(
        private authService: AuthenticationService,
        private translateService: TranslateService,
        private navigationService: NavigationService
    ) {
    }

    ngOnInit(): void {
        this.currentUser = this.authService.getUserDetails();

        if (this.currentUser?.userBusinessType !== UserBusinessType.TechnicalProductionUser) {
            this.navigateForUser(this.currentUser);
        }
    }

    onScan(boschId: string): void {
        if (this.isLoading) {
            return;
        }

        this.errorMessage = null;
        this.isLoading = true;
        this.authService.preserveTechnicalUserSession('/scan-badge');

        this.authService.loginWithBoschId(boschId).subscribe(
            () => {
                this.isLoading = false;
                this.navigateForUser(this.authService.getUserDetails());
            },
            (error) => {
                this._logger.error('onScan:: API returned error', error);
                this.isLoading = false;
                this.errorMessage = this.translateService.instant('technicalProductionScan.error');
            }
        );
    }

    private navigateForUser(user: JWTUser): void {
        this.navigationService.navigateToDefaultRoute(user);
    }
}
